export interface PlatformState {
  platform: string;
  website: string;
  website_invalid: boolean;
  maxMonthlyOrders?: string;
  phone?: string;
  popover: boolean;
  saving: boolean;
};

export const initialPlatformState: PlatformState = {
  platform: null,
  website: '',
  website_invalid: false,
  popover: false,
  saving: false
};

export function cloneState(other: PlatformState): PlatformState {
  return Object.assign({}, other);
}
